<template>
  <v-card
    outlined
    elevation="4"
    class="d-flex flex-column pa-2 mt-5"
  >
    <v-btn
      class="align-self-end"
      outlined
      download
      color="primary"
      :href="linkExcelExemplo"
    >
      <div>
        <v-icon left>
          {{ icons.mdiMicrosoftExcel }}
        </v-icon>
        <span>Download Excel de exemplo</span>
      </div>
    </v-btn>

    <div
      v-if="opcoesExcel.length > 0"
      class="d-flex align-center align-self-end mt-2"
    >
      <span class="text-caption me-3">{{ opcoesExcel.length }} opções já cadastradas</span>
      <v-btn
        outlined
        color="primary"
        @click="baixarArquivoAtual"
      >
        <v-icon left>
          {{ icons.mdiMicrosoftExcel }}
        </v-icon>
        <span>Baixar arquivo atual</span>
      </v-btn>
    </div>

    <v-file-input
      ref="excelInputRef"
      class="mt-3"
      show-size
      validate-on-blur
      label="Importar Excel com dados encadeados"
      accept=".xlsx, .xlsm, .xltx, .xltm, .xlsb, .xlam"
      @change="uploadExcel"
    />
  </v-card>
</template>

<script>
import { mdiMicrosoftExcel } from '@mdi/js'
import { ref } from '@vue/composition-api'
import * as XLSX from 'xlsx'

export default {
  props: {
    opcoesExcel: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const excelInputRef = ref(null)
    const opcoesExcelLocale = ref([])

    const uploadExcel = file => {
      if (!file) return

      const reader = new FileReader()
      reader.readAsBinaryString(file)
      reader.onload = e => {
        const fileData = e.target.result
        const workbook = XLSX.read(fileData, { type: 'binary' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
        opcoesExcelLocale.value = rows
          .slice(1)
          .filter(linha => linha.length > 0)
          .map(linha => linha.map(celula => celula.toString()))
        emit('update:opcoes-excel', opcoesExcelLocale.value)
      }
    }

    const linkExcelExemplo = 'https://vikdocumentdb.blob.core.windows.net/utils/TemplateDadosComponentesEncadeados.xlsx?sv=2021-10-04&st=2024-07-25T20%3A58%3A20Z&se=2031-12-31T20%3A58%3A00Z&sr=b&sp=r&sig=RQnW1KAYIDDQzVXwn3Hu4rw9nphDeCrW3FwJAF2nIjA%3D'

    const baixarArquivoAtual = () => {
      const qtdeColunas = props.opcoesExcel[0]?.length || 1
      const cabecalho = Array.from({ length: qtdeColunas }, (_, i) => `Coluna ${i + 1}`)
      const linhas = [cabecalho, ...props.opcoesExcel]

      const worksheet = XLSX.utils.aoa_to_sheet(linhas)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
      const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'dados-encadeados-atual.xlsx'
      a.click()
      URL.revokeObjectURL(url)
    }

    return {
      excelInputRef,
      uploadExcel,
      baixarArquivoAtual,
      icons: {
        mdiMicrosoftExcel,
      },
      linkExcelExemplo,
    }
  },
}
</script>
